export const OPEN_DATASET_EVALUATOR_FOR_EDIT_TOOL_NAME =
  "open_dataset_evaluator_for_edit";
